import React from 'react'

export type RenderLayoutProps = {
  id: string
  parentKey: string
  depth: number
  isExpandable: boolean

  isActive: boolean
  isExpanded: boolean

  onToggleExpand: (id: string) => void
  onDropNote: () => void
}

export type SidebarEntryProps = Omit<
  RenderLayoutProps,
  'layoutRef' | 'onKeyDown'
> & {
  isScrollTarget: boolean
  onFocusNextRow: () => void
  onFocusPreviousRow: () => void
  renderLayout: (props: RenderLayoutProps) => React.ReactElement
}

export const SidebarEntry = ({
  id,
  parentKey,
  depth,
  isExpandable,
  renderLayout,

  isActive,
  isExpanded,

  onToggleExpand,
  onDropNote,
}: SidebarEntryProps) => {
  return renderLayout({
    id,
    parentKey,
    depth,

    isExpandable,
    isActive,
    isExpanded,

    onToggleExpand,
    onDropNote,
  })
}
